module.exports = __webpack_public_path__ + "static/agua-69a7b3dac62046d5ff870558b2818778.jpg";